var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4Zm0-7c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3ZM5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm13 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm13 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm-.774 5c-1.634 0-3.087-.39-4.492-.767-1.404-.377-2.731-.733-4.233-.733-.759 0-1.637.126-2.486.248-.854.123-1.737.25-2.514.25-1.897 0-3.501-1.667-3.501-3.64V8.154A4.721 4.721 0 0 1 3.028 3.77C4.37 3.259 5.63 3 6.774 3c1.634 0 3.087.39 4.492.767 1.405.377 2.731.733 4.233.733.844 0 1.97-.14 2.964-.264.838-.104 1.562-.194 2.036-.194 1.896 0 3.499 1.667 3.499 3.639v8.165a4.722 4.722 0 0 1-3.029 4.384c-1.341.511-2.601.77-3.745.77ZM8.5 18.5c1.634 0 3.087.39 4.493.767 1.405.377 2.731.733 4.233.733 1.022 0 2.162-.237 3.39-.705a3.67 3.67 0 0 0 2.385-3.449V7.681c0-1.431-1.146-2.639-2.5-2.639-.413 0-1.142.091-1.913.187-1.022.127-2.182.271-3.087.271-1.634 0-3.087-.39-4.492-.767C9.604 4.356 8.278 4 6.776 4c-1.021 0-2.162.237-3.39.705a3.668 3.668 0 0 0-2.385 3.449v8.205c0 1.431 1.146 2.639 2.5 2.639.706 0 1.515-.116 2.372-.239.884-.127 1.798-.258 2.628-.258Z",
    fill: "currentColor",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.2490f34beafd3cb932fecf5b37720517.svg";
export { ForwardRef as ReactComponent };